export default Object.freeze({
  METRES: 1,
  MILES: 2,
});
